var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"sx-container sx-layout-center"},[_c('div',{staticClass:"sx-align-center"},[_c('a-spin'),_c('p',{staticClass:"load-text"},[_vm._v(_vm._s(_vm.loadingText))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }